import { Component, Input, OnInit } from '@angular/core';
import { faFilter, IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { SkillGroup } from 'src/app/store/samwin/samwin-skills/skill-group';

@Component({
   selector: 'samweb-skill-filter-bar',
   templateUrl: './skill-filter-bar.component.html',
   styleUrls: ['./skill-filter-bar.component.scss'],
})
export class SkillFilterBarComponent implements OnInit {
   @Input()
   isFilteredBySkill: boolean;

   @Input()
   filteredGroupTranslationValue = '';

   @Input()
   filteredSkill: SkillGroup;

   public statusBarFilterIcon: IconDefinition = faFilter;

   constructor() {}

   ngOnInit(): void {}
}
